export const API_CASINO_BASE = '/casino/api/internal';
export const API_CASINO_ACCOUNT_BASE = '/casino/api/internal/account';

export const API_CASINO_NEWS = `${API_CASINO_BASE}/news`;
export const API_CASINO_NEWS_LIMITED = `${API_CASINO_NEWS}/limited`;

export const API_CASINO_GAMES_LIMITED = `${API_CASINO_BASE}/limited-games`;
export const API_CASINO_GAME_CATEGORIES = `${API_CASINO_BASE}/game-categories`;
export const API_CASINO_GAME_BLOCKS = `${API_CASINO_BASE}/game-category-blocks`;

export const API_CASINO_ACCOUNT_TRANSACTIONS = `${API_CASINO_ACCOUNT_BASE}/transactions`;
export const API_CASINO_ACCOUNT_ACTIVE_BALANCE = `${API_CASINO_ACCOUNT_BASE}/active-balance`;
